export default __webpack_public_path__ + "static/media/96_mobile.7aea0629.jpg";